import React, { useState } from "react";
import { Link } from "react-router-dom"; // Importando Link do react-router-dom
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons";

// Função para rolar suavemente para uma âncora
function smoothScrollTo(anchor) {
  const target = document.querySelector(anchor);
  if (target) {
    window.scrollTo({
      top: target.offsetTop,
      behavior: "smooth",
    });
  }
}

export default function MenuVariaveisSalesbox() {
  const sections = [
    {
      path: "/variaveis-demograficas",
      title: "Variáveis demográficas",
      subItems: [
        { title: "Renda", anchor: "#renda" },
        { title: "Dados Cadastrais Básicos", anchor: "#dados-basicos" },
        { title: "Dados Cadastrais Avançados", anchor: "#dados-avancados" },
      ],
    },
    {
      path: "/variaveis-psicograficas",
      title: "Variáveis psicográficas",
      subItems: [
        { title: "Segmentação Psicográfica", anchor: "#segmentacao" },
        { title: "Afinidades a Tipo de Ofertas", anchor: "#afinidades" },
      ],
    },
    {
      path: "/variaveis-financeiras",
      title: "Variáveis financeiras",
      subItems: [
        { title: "Score de Crédito", anchor: "#score" },
        { title: "Risco Financeiro", anchor: "#risco" },
      ],
    },
  ];

  const [expandedSection, setExpandedSection] = useState(null);

  function isPaginaEspecifica(path) {
    return window.location.pathname === path;
  }

  function toggleSection(index) {
    setExpandedSection(expandedSection === index ? null : index);
  }

  function handleClick(anchor) {
    smoothScrollTo(anchor);
  }

  return (
    <div>
      <h4>Artigos nessa seção</h4>
      <ul
        className="nav categories-nav nav-pills flex-column"
        role="navigation"
      >
        {sections.map((section, index) => (
          <li className="nav-item open" key={index}>
            <Link
              to={section.path} // Usando o componente Link para a navegação
              className={`nav-link ${
                isPaginaEspecifica(section.path) ? "active" : ""
              }`}
              onClick={() => toggleSection(index)}
            >
              <FontAwesomeIcon
                icon={expandedSection === index ? faAngleDown : faAngleRight}
                className="mr-2"
              />
              {section.title}
            </Link>
            {expandedSection === index && (
              <ul
                className="nav nav-pills flex-column sub-items"
                style={{ userSelect: "none" }}
              >
                {section.subItems.map((subItem, subIndex) => (
                  <li className="nav-item" key={subIndex}>
                    <a
                      className="nav-link"
                      onClick={() => handleClick(subItem.anchor)}
                    >
                      {subItem.title}
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
